const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const pad = (value) => String(value).padStart(2, '0');

const formatParts = (year, month, day, hour, minute) => {
  const hourNumber = Number(hour);
  const period = hourNumber >= 12 ? 'pm' : 'am';
  const displayHour = hourNumber % 12 || 12;
  return `${Number(day)} ${MONTHS[Number(month) - 1]} ${year}, ${pad(displayHour)}:${pad(minute)} ${period}`;
};

export const formatKolkataDateTime = (value, { dateOnly = false } = {}) => {
  if (!value) return '-';

  const text = String(value).trim();
  const dateOnlyMatch = text.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (dateOnlyMatch) {
    const [, year, month, day] = dateOnlyMatch;
    return `${Number(day)} ${MONTHS[Number(month) - 1]} ${year}`;
  }

  const localMatch = text.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::\d{2})?/);
  if (localMatch) {
    const [, year, month, day, hour, minute] = localMatch;
    return dateOnly
      ? `${Number(day)} ${MONTHS[Number(month) - 1]} ${year}`
      : formatParts(year, month, day, hour, minute);
  }

  const date = new Date(text);
  if (Number.isNaN(date.getTime())) return text;
  return date.toLocaleString('en-IN', {
    timeZone: 'Asia/Kolkata',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    ...(dateOnly ? {} : { hour: '2-digit', minute: '2-digit', hour12: true }),
  });
};
